import Vue from 'vue';
import {
  toast,
  modal,
  Button,
  ButtonLine,
  ButtonGroup,
  Cell,
  CellLeft,
  CellRight
} from '@mx/vix';

[Button, ButtonLine, ButtonGroup, Cell, CellLeft, CellRight].map((c) =>
  Vue.use(c)
);

export { toast, modal };

Vue.prototype.$toast = toast;
Vue.prototype.$modal = modal;

export * from './env';
export * from './api';
export * from './bridge';
export * from './encrypt';
export * from './analytics';
export * from './openApi';
